import { ITag } from '#types/tags';
import * as iconModule from 'react-icons/bi';
import styled from 'styled-components';

interface ItemListProps {
  itemList: ITag[];
  onClick: (tag: string) => void;
  selectedTags: string[];
}

const imageMap = {
  근력강화: '/images/근력강화.png',
  다이어트: '/images/다이어트.png',
  대회준비: '/images/대회준비.png',
  바디프로필: '/images/바디프로필.png',
  재활치료: '/images/재활치료.png',
  체력증진: '/images/체력증진.png',
  체형교정: '/images/체형교정.png',
  통증관리: '/images/통증관리.png'
};

const ItemList = ({ selectedTags, itemList, onClick }: ItemListProps) => {
  return (
    <div className="flex flex-wrap gap-x-20 gap-y-24">
      {itemList.map(item => {
        // const img = imageMap[item.name as keyof typeof imageMap];

        // if (!img) return null;

        const isSelected = selectedTags.includes(item.id);

        const Icon =
          iconModule[
            (item.iconName || 'BiSolidImageAlt') as keyof typeof iconModule
          ];

        return (
          <div
            onClick={() => onClick(item.id)}
            className="relative flex flex-col gap-10"
          >
            {isSelected && <Check />}
            <Circle isSelected={isSelected}>
              {/* <img src={img} width={40} height={40} alt={item.name} /> */}
              {/* <ReactIcon iconName={item.iconName ?? ''} /> */}
              <Icon
                style={{
                  width: '40px',
                  height: '40px'
                }}
                fill={isSelected ? 'white' : 'gray'}
              />
            </Circle>
            <Text>{item.name}</Text>
          </div>
        );
      })}
    </div>
  );
};

const Check = () => {
  return (
    <div className="absolute right-[4px] top-[4px] w-22 h-22 bg-[#7750E9] flex justify-center items-center rounded-[50%]">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="19"
        height="18"
        viewBox="0 0 19 18"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5 7.5L3.5 9L8 13.5L15.5 6L14 4.5L8 10.5L5 7.5Z"
          fill="white"
        />
      </svg>
    </div>
  );
};

const Circle = styled.div<{ isSelected: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 88px;
  height: 88px;
  border-radius: 48px;
  border: ${({ isSelected }) => (isSelected ? '2px' : '1px')} solid
    ${({ isSelected }) =>
      isSelected ? '#7750E9' : 'var(--gray-600---border2, #2e2b36)'};
  background: var(--gray-800---bg2, #1f1e25);
`;

const Text = styled.div`
  color: var(--gray-25, #c9c7d1);
  text-align: center;

  /* Body 3/R */
  font-family: 'Pretendard Variable';
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
  letter-spacing: -0.24px;
`;

export default ItemList;
